import { AddOrgMemberRequestSchema, AddOrgMemberResponseSchema } from './add-org-member.schema';
/**
 * Add Org Member Endpoint Contract
 * Creates a new organization member
 */ export const addOrgMemberContract = {
    method: 'POST',
    path: '/api/v2/org-member',
    description: 'Create a new organization member',
    requestSchema: AddOrgMemberRequestSchema,
    responseSchema: AddOrgMemberResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=add-org-member.contract.js.map